<div class="bg-white rounded-[10px] min-h-full overflow-x-hidden">
  <img class="w-full" [src]="demoImg" alt="" />

  <div
    class="fixed bottom-[36px] right-[66px] p-[36px] mx-[30px] bg-white border border-solid border-c-gb rounded-xl"
    [ngClass]="{
      'left-[206px]': !isInternational,
      'left-[246px]': isInternational
    }"
    [ngStyle]="demoCardStyle"
  >
    <div class="text-[28px] leading-[34px]">
      {{ demoCardTitle }}
    </div>
    <div class="text-m mt-[16px]">
      {{ demoCardDesc }}
    </div>

    <ng-content select=".demo-card-btns"></ng-content>
  </div>
</div>
